import React, { useEffect, useState } from 'react'; 
import styles from './../../Assets/CSS/Login.module.css';
import axios from 'axios';
import { BASE_URL } from './../../Environment';
import loginImg from './../../Assets/Images/loginImage.svg';
import { FaEye, FaEyeSlash, FaIdCardAlt } from 'react-icons/fa';
import { Link } from 'react-router-dom';
import { BlueButton } from './../../Components/Button';
import { toast } from 'react-toastify';
 
function Login() { 
    const [showPassword, setShowPassword] = useState(false);
    const [isLoading, setIsLoading] = useState(false);
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    useEffect(() => {
        document.title = 'Infomart | Client Login'; 
    }, []);   
    const handleLogin = async () => {
        setIsLoading(true); 
        await axios.post(`${BASE_URL}/vendor/login`, { email, password }, {
            headers: {  
                'Content-Type': 'application/json'
            }
        }).then((res) => {
            toast.success(res.data.msg, { autoClose: 3000 });
            setIsLoading(false);
            localStorage.setItem('loginAs', 'Client');    
            localStorage.setItem('accessToken', res.data.accessToken);  
            window.location.reload(); 
        }).catch((res) => {    
            toast.error(res.response.data.msg, { autoClose: 3000 }); 
            setIsLoading(false);  
        });   
    } 
    return (
        <div className="app"> 
            <div className="outlet">
                <div className={styles.loginPageContainer}>
                    <div className={styles.loginFormContainer}>
                        <div className={styles.imgContainer}>
                            <img src={loginImg} className={styles.img} />
                        </div>
                        <div className={styles.contentContainer}>
                            <h3>Login</h3>
                            <div className={styles.loginForm}>
                                <div className={styles.inputContainer}>
                                    <input type="text" className={styles.input} placeholder="Enter Email ID *" onChange={e => setEmail(e.target.value)} />
                                    <FaIdCardAlt color="gray" />
                                </div>
                                <div className={styles.inputContainer}>
                                    <input type={showPassword ? "text" : "password"} className={styles.input} placeholder="Enter Password *" onChange={e => setPassword(e.target.value)} />
                                    {showPassword ? 
                                        <FaEye color="gray" onClick={() => setShowPassword(!showPassword)} />
                                        :
                                        <FaEyeSlash color="gray" onClick={() => setShowPassword(!showPassword)} />
                                    }
                                </div>
                                <Link to="/client/forgot-password" className={styles.link}>Forgot Password?</Link>
                            </div>   
                            <div>
                                <BlueButton title={isLoading ? "Loading..." : "Login"} onClick={() => handleLogin()} />
                            </div>
                        </div>
                    </div>
                </div>
            </div> 
        </div>
    );
}

export default Login;    